import React from 'react';

interface LoadingIconProps {
    size?: number;
    className?: string;
    color?: string;
    rotate?: boolean;
}

const LoadingIcon: React.FC<LoadingIconProps> = ({ size = 22, className="",color="white",rotate=false }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className+" "+(rotate ? 'matchid-rotate' : '')}
    >
        <path d="M11 1V3.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.3" d="M3.92834 3.92871L5.69977 5.70017" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.4" d="M1 11H3.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.5" d="M3.92834 18.0722L5.69977 16.3008" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.6" d="M11 21V18.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.7" d="M18.0715 18.0722L16.3 16.3008" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.8" d="M21 11H18.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.9" d="M18.0715 3.92871L16.3 5.70017" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default LoadingIcon;